import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class WindowService {
  private _window: Window;
  constructor(@Inject(PLATFORM_ID) platformId) {
    if (!isPlatformBrowser(platformId)) {
      this._window = {} as Window;
    } else {
      this._window = window;
    }
  }

  get nativeWindow(): any {
    return this._window;
  }
}
